export var STRUCTURE_CONTENT_CONSTRAINTS_PATH = ['data', 'contentConstraints'];
export var ACTUAL = 'Actual';
export var CONTENT_CONSTRAINTS_TIME_PERIOD = 'TIME_PERIOD';